module.exports = __webpack_public_path__ + "img/collection-es.2b3847d3.png";